
import { Description as DescriptionIcon, Assignment as AssignmentIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

import type { LetterType } from '@/apps/engagement-letter-database/data/types';

interface PageHeaderProps {
  letterType: LetterType;
}

const PageHeader = ({ letterType }: PageHeaderProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {letterType === 'engagement' ? (
        <DescriptionIcon sx={{ mr: 1, fontSize: 32, color: 'primary.main' }} />
      ) : (
        <AssignmentIcon sx={{ mr: 1, fontSize: 32, color: 'secondary.main' }} />
      )}
      <Typography variant="h4">Search {letterType === 'engagement' ? 'Engagement' : 'Waiver'} Letters</Typography>
    </Box>
  );
};

export default PageHeader;
